import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Paper, Typography, Box, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';
import { internshipDomain } from '../util/domain';

const ThankYou = () => {
    const { registrationHashId } = useParams();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [countdown, setCountdown] = useState(10);

    useEffect(() => {
        const fetchEventDetails = async () => {
            setLoading(true);
            setError('');
            try {
                const regRes = await axios.get(`${internshipDomain}/api/registration/${registrationHashId}`);
                if (regRes.data.success && regRes.data.registration) {
                    const eventHashId = regRes.data.registration.event_hash_id;
                    const eventRes = await axios.get(`${internshipDomain}/api/events/${eventHashId}`);
                    if (eventRes.data.success && eventRes.data.event) {
                        setEvent(eventRes.data.event);
                    } else {
                        setError('Event details not found');
                    }
                } else {
                    setError('Registration not found');
                }
            } catch (err) {
                setError('Failed to fetch event details');
            } finally {
                setLoading(false);
            }
        };
        fetchEventDetails();
    }, [registrationHashId]);


    useEffect(() => {
        // Countdown timer
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    // Redirect to vectorindia.org after 30 seconds
                    window.location.href = 'https://vectorindia.org';
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        // Cleanup timer on unmount
        return () => clearInterval(timer);
    }, []);

    if (loading) {
        return (
            <Container maxWidth="sm">
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            </Container>
        );
    }

    if (error) {
        return (
            <Container maxWidth="sm">
                <Alert severity="error" sx={{ mt: 4 }}>{error}</Alert>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm">
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                <img src="/logo-vector.svg" alt="Vector India Logo" style={{ height: '60px', width: 'auto' }} />
            </Box>
            <Paper elevation={3} sx={{ p: 4, mt: 2 }}>
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Thank You for Registering!
                </Typography>
                <Typography variant="body1" align="center" sx={{ mb: 3 }}>
                    Your registration is successful.
                </Typography>
                <Box sx={{ my: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
                    <Typography variant="body2" sx={{ color: '#888888', fontStyle: 'italic' }}>
                        Redirecting to Vector India website in {countdown} seconds...
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default ThankYou; 